import React from 'react';
import { Routes, Route } from 'react-router-dom';
import styled from 'styled-components';

// Layout components
import Header from './components/layout/Header';
import Sidebar from './components/layout/Sidebar';
import Footer from './components/layout/Footer';

// Pages
import HomePage from './pages/HomePage';
import PostDetailPage from './pages/PostDetailPage';
import MessagingPage from './pages/MessagingPage';
import UserProfilePage from './pages/UserProfilePage';
import GroupDiscoveryPage from './pages/GroupDiscoveryPage';
import GroupPage from './pages/GroupPage';
import CreatePostPage from './pages/CreatePostPage';
import NotificationsPage from './pages/NotificationsPage';
import NotFoundPage from './pages/NotFoundPage';

const AppContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`;

const MainContent = styled.main`
  display: flex;
  flex: 1;
`;

const ContentArea = styled.div`
  flex: 1;
  padding: ${({ theme }) => theme.spacing.lg};

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    padding: ${({ theme }) => theme.spacing.md};
  }
`;

function App() {
  return (
    <AppContainer>
      <Header />
      <MainContent>
        <Sidebar />
        <ContentArea>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/post/:postId" element={<PostDetailPage />} />
            <Route path="/messages" element={<MessagingPage />} />
            <Route path="/messages/:userId" element={<MessagingPage />} />
            <Route path="/profile/:username" element={<UserProfilePage />} />
            <Route path="/discover" element={<GroupDiscoveryPage />} />
            <Route path="/group/:groupId" element={<GroupPage />} />
            <Route path="/create-post" element={<CreatePostPage />} />
            <Route path="/notifications" element={<NotificationsPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </ContentArea>
      </MainContent>
      <Footer />
    </AppContainer>
  );
}

export default App;
